import { TrackedEvent } from './trackedEvent';

export interface PageVisitTrackEvent {
    pageName: string;
    properties: object;
}

export interface UserActionTrackEvent {
    event: TrackedEvent;
    properties: object;
}

export class UserActionTrackEventBase implements UserActionTrackEvent {
    constructor(public event: TrackedEvent, public properties: object = {}) {}
}
